import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Maintenance Guard
 * Redirects all routes to maintenance page when maintenanceMode is enabled
 */
export const maintenanceGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Si está en modo mantenimiento y NO es la ruta de mantenimiento
  if (environment.features?.maintenanceMode && state.url !== '/maintenance') {
    router.navigate(['/maintenance']);
    return false;
  }

  // Si NO está en modo mantenimiento pero intenta acceder a /maintenance
  if (!environment.features?.maintenanceMode && state.url === '/maintenance') {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
